import * as React from 'react'

import { TFUserAgreement } from '~graphql/generated/clientGraphql'
import { InputCheckbox } from '~ui/components/formElements/Checkbox/InputCheckbox'
import { GridRow } from '~ui/components/layout/Box'

import { AgreementLabel } from './AgreementLabel'

type TProps = NoChildren & {
  isChecked: boolean
  isDisabled: boolean
  onChange: () => void
  agreement: TFUserAgreement
}

/**
 * An agreement (checkbox + clickable, expandable label) in the order form.
 */
export const Agreement: React.FC<TProps> = ({ agreement, isChecked, onChange, isDisabled }) => {
  return (
    <GridRow gridTemplateColumns={`auto 1fr`} columnGap={`medium`}>
      <InputCheckbox
        onChange={onChange}
        value={agreement.id}
        isChecked={isChecked}
        isDisabled={isDisabled}
        isRequired={agreement.isMandatory}
      />
      <AgreementLabel agreement={agreement} onLabelClick={isDisabled ? undefined : onChange} />
    </GridRow>
  )
}
